import api from "@/services/api"

type SendOrderReceiptRequest = {
  email?: string
  sms?: string
}

export const sendTransactionReceipt = async (
  transactionId: string,
  params: SendOrderReceiptRequest
) => {
  await api.post(
    `/transactions/${transactionId}/send-receipt/`,
    {
      body: params,
    }
  )
}
